import { Component, OnInit } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { DiagnosticoCliente } from '../diagnostico/Diagnostico.entity';
import { DiagnosticoclienteHttpService } from '../diagnosticocliente-http.service';
import { MatDialogRef } from '@angular/material';
import { NavegacionService } from '../sidenav.service';

@Component({
  selector: 'app-diagnosticos-edicion',
  templateUrl: './diagnosticos-edicion.component.html',
  styleUrls: ['./diagnosticos-edicion.component.css']
})
export class DiagnosticosEdicionComponent implements OnInit {

  diagnosticoSeleccionado: DiagnosticoCliente = null;
  private _operacion = 'agregar';

  constructor(
    private _router: Router,
    public navegacionServices: NavegacionService,
    private _activeRoute: ActivatedRoute,
    private DiagnosticoClienteSrv: DiagnosticoclienteHttpService,
    public dialogRef: MatDialogRef<DiagnosticosEdicionComponent>,
  ) { }

  ngOnInit() {
    const id = Number( this._activeRoute.snapshot.paramMap.get('id')) ;
    // this._operacion =  this._activeRoute.snapshot.paramMap.get('operacion');
    if (this._operacion === 'editar') {
      this.DiagnosticoClienteSrv.Get(id).subscribe( diagnostico => {
        this.diagnosticoSeleccionado = diagnostico;
      });
    } else {
      // console.log(this.navegacionServices._currentClient);
      const clientid = this.navegacionServices.currentClient.clienteID;
      this.diagnosticoSeleccionado = new DiagnosticoCliente(0, '', clientid);
    }

  }

  Regresar() {
    // this._router.navigate(['/diagnostico']);
    this.dialogRef.close();
  }

  Guardar(form: any) {

    Object.keys(form).forEach((key, index) =>
      this.diagnosticoSeleccionado[key] = form[key]
    );
    // let id = 0;
   // console.log(this._operacion);
    if (this._operacion === 'editar') {
      this.DiagnosticoClienteSrv.Update(this.diagnosticoSeleccionado);
    } else {
      this.DiagnosticoClienteSrv.Add(this.diagnosticoSeleccionado).subscribe(
        obj => {
          // id = obj.diagnosticoID;
        });
    }
    this.dialogRef.close();

  }


}



// WEBPACK FOOTER //
// ./src/app/diagnosticos-edicion/diagnosticos-edicion.component.ts